module.exports = __webpack_public_path__ + "img/header_kdykoliv.13e66846.jpg";